module.exports = __webpack_public_path__ + "static/media/address_icon.9f82e63b.png";